import { useEffect, useRef, useState } from "react";
import { Globe, Check } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { LANGS } from "@/i18n/detectLanguage";

const LANG_LABELS = {
  "zh-CN": "简体中文",
  "zh-TW": "繁體中文",
  en: "English",
  vi: "Tiếng Việt",
  th: "ภาษาไทย",
  ms: "Bahasa Melayu",
};

export default function LanguageSwitcher({ inline = false }) {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [open]);

  return (
    <div ref={ref} className={inline ? "relative" : "fixed right-4 top-4 z-[60]"}>
      <button
        type="button"
        data-testid="language-switcher-button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="flex items-center gap-1.5 rounded-full border border-[rgba(22,99,230,0.3)] bg-white/85 px-3.5 py-2 text-xs font-medium text-[#0B3D91] shadow-sm backdrop-blur-md transition-colors hover:bg-[rgba(22,99,230,0.08)] active:scale-95"
      >
        <Globe className="h-4 w-4" strokeWidth={1.75} />
        {LANG_LABELS[lang]}
      </button>
      {open && (
        <div
          data-testid="language-menu"
          className="absolute right-0 mt-2 w-44 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-xl"
        >
          {LANGS.map((l) => (
            <button
              key={l}
              type="button"
              data-testid={`language-option-${l}`}
              onClick={() => {
                setLang(l);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between px-4 py-2.5 text-left text-xs transition-colors ${
                l === lang ? "font-semibold text-[#1663E6]" : "text-slate-600 hover:bg-slate-50"
              }`}
            >
              {LANG_LABELS[l]}
              {l === lang && <Check className="h-3.5 w-3.5" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
